module.exports = __webpack_public_path__ + "img/logo_footer.daabcd5a.png";